import { getCompleteDateValue } from '@/pages/dashboard/utils/utils';
import { StudioContext } from '@home/pages/studio/context';
import { getCommonApi } from '@home/services/studio';
import dateTimeFormat from '@home/utils/dbDataFormat/dateTimeFormat';
import React, { useContext, useEffect, useState } from 'react';

const KolTableService = (props: any) => {
  const {
    api,
    children,
    filterVal,
    filterLoading,
    extraParams,
    expandExtraParams,
    percentKeys,
    ...restProps
  } = props || {};
  const { currentGame } = useContext(StudioContext);
  const { game_code, studio_code } = currentGame || {};
  const [loading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [tableCount, setTableCount] = useState(0);
  const [params, setParams] = useState<any>();

  useEffect(() => {
    const {
      date,
      isSingle,
      campaign_name,
      region_country,
      channel_name,
      fix_language,
      platform,
      content,
      format,
    } = filterVal || {};

    // 防止初始化date为空
    if (!date) return;
    const [start_time, end_time] = date || [];
    let startDate = dateTimeFormat(start_time, 'day');
    const rangeTime = date;
    // 补齐逻辑
    if (isSingle) {
      const rangeTimeArr = getCompleteDateValue(rangeTime, 'day');
      startDate = dateTimeFormat(rangeTimeArr[0], 'day');
    }
    const initPamras: any = {
      studio_code,
      game_code,
      start_time: startDate,
      end_time: dateTimeFormat(end_time, 'day'),
      filters: {
        campaign_name_list: campaign_name,
        region_country_list: region_country?.market,
        channel_name_list: channel_name,
        fix_language_list: fix_language,
        platform_list: platform,
        content_list: content,
        format_list: format,
      },
      ...(extraParams || {}),
    };
    const filterValue = { ...initPamras };
    if (params?.page_size) {
      filterValue.page_size = params?.page_size;
    }
    setParams(filterValue);
  }, [extraParams, filterVal, game_code, studio_code]);

  // 计算某些列的占比
  const formatPercetData = (list: any[], currentData: any) => {
    percentKeys?.forEach((key: string) => {
      const { [key]: total } = currentData || {};
      list?.forEach(item => {
        const metric = item?.metrics?.[key];
        if (metric) {
          item.metrics[key].percent = total?.value && metric?.value ? (Number(metric?.value) / Number(total?.value)) : '';
        }
      });
    });
    return list;
  };

  // 获取表格数据
  const getTableData = (params: any) => {
    setLoading(true);
    // 特殊处理, 需除掉total常驻
    getCommonApi({ ...params, page_size: params.page_size - 1 }, api)
      .then((data) => {
        const { count, list } = data || {};

        const newData = formatPercetData(list, list?.[0]?.metrics);

        const newList =
          newData?.map((item: any, index: number) => {
            // total不需要展开
            if (index === 0) {
              return { key: item.campaign_name, ...item };
            }
            return { key: item.campaign_name, ...item, children: [] };
          }) || [];
        setTableCount(count ? count + 1 : 0);
        setTableData(newList);
      })
      .catch((error) => {
        console.log('- getTableData - error>>', error);
        setIsError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 获取二级逻辑
  const getSecTableData = (key: string, tableData: any[]) => {
    // 防止多次触发请求
    if (loading) return;
    const currentData = tableData?.find(
      (item: any) => item.campaign_name === key,
    ) || {};
    const hasChildren = currentData?.children?.length > 0;
    if (hasChildren) return;
    setLoading(true);
    const {
      studio_code,
      game_code,
      start_time,
      end_time,
      filters,
      order_by,
      metrics,
    } = params;
    const newParams = {
      studio_code,
      game_code,
      start_time,
      end_time,
      filters: {
        ...(filters || {}),
        campaign_name_list: [key],
      },
      order_by,
      metrics,
      ...(expandExtraParams || {}),
    };
    getCommonApi(newParams, api)
      .then((data) => {
        const { list } = data || {};

        const newList = formatPercetData(list, currentData?.metrics);

        const newTableData: any[] =
          tableData?.map((item: any) => {
            // 插入children数据
            if (item?.campaign_name === key) {
              return {
                ...item,
                children: newList?.map((item: any) => ({
                  ...item,
                  isChildren: true,
                  key: item.channel_name,
                })),
              };
            }
            return item;
          }) || [];

        setTableData(newTableData);
      })
      .catch((error) => {
        console.log('- getTableData - error>>', error);
        setIsError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (filterLoading) return;
    if (!params) return;
    getTableData(params);
  }, [filterLoading, params]);

  return React.Children.map(children, (child: any) =>
    React.cloneElement(child, {
      tableData,
      params,
      loading,
      isError,
      tableCount,
      defaultSort: extraParams?.order_by,
      filterVal,
      setParams,
      getSecTableData,
      ...(restProps || {}),
    }),
  );
};

export default KolTableService;
